import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import CategoryGridSection from "./components/CategoryGridSection";
import SeoContentSection from "./components/SeoContentSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import FinalCtaSection from "./components/FinalCtaSection";

export default function Home() {
  return (
    <main>
      <Navbar />
      <article>
        <HeroSection />
        <TrustSection />
        <CategoryGridSection />
        <SeoContentSection />
        <TestimonialSection />
        <FaqSection />
        <FinalCtaSection />
      </article>
      <Footer />
    </main>
  );
}